module.exports = __webpack_public_path__ + "img/cover_2.68c560f0.png";